<ngx-spinner bdColor="rgba(51,51,51,0.55)"
    size="medium"
    color="#fff"
    type="line-spin-clockwise-fade"
    [fullScreen]="false">
    <p class="loading">{{ 'general.loading' | translate }}...</p>
</ngx-spinner>
<div class="modal-header navbar-alertia">
    <h4 class="modal-title">{{'register.validate_email' | translate}}</h4>
</div>
<div class="modal-body text-break">
    <form [formGroup]="verifyEmailForm" [ngClass]="{ 'was-validated': formSubmitted }" (ngSubmit)="verifyCode()" name="form">
        <div class="row mt-1">
            <div class="col-12">
                <label for="VerificationCode" class="text-center">{{'register.enter_code' | translate}} <strong>{{email}}</strong></label>
                <input id="VerificationCode" type="text" formControlName="VerificationCode" class="form-control" maxlength="50" 
                    placeholder="{{'register.verification_code' | translate}}" [ngClass]="{ 'is-valid': VerificationCode['valid'], 'is-invalid': VerificationCode['invalid'] }"/>
                <ng-container *ngIf="verifyEmailForm.get('VerificationCode').invalid && formSubmitted">
                    <div *ngIf="verifyEmailForm.get('VerificationCode').hasError('required')"  class="error align-left">
                        {{'general.required_field' | translate}}
                    </div>
                </ng-container>
                <div class="text-right">
                    <a tabindex="0" (keydown.enter)="resendCode()" (click)="resendCode()">
                        {{'register.resend_code' | translate}}
                    </a>
                </div>
                <div id="re-sent" class="m-1 text-center"></div>
            </div>
        </div>
        <div class="row">
            <div class="col-12 text-center">
                <button type="submit" class="btn btn-alertia btn-green btn-h-green">
                    {{'register.validate' | translate}}
                </button>
                <div id="code_error" class="error mt-2"></div>
            </div>
        </div>
    </form>
</div>
